import React from 'react';
import { Button, Col, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import _ from 'lodash'
import api from '../../api';
import './index.css';
import utils from '../../resources/utils';
import Constant from '../../constants';
import DataObject from '../../components/DataObject';

export default class UserManagement extends React.Component {
    constructor(props) {
        super(props);
        const query_params = utils.parseQueryParams(this.props);
        this.state = {
            searchKeyword: '',
            datasources: [],
            users: [],
            searchResultCount: 0,
            isSearching: false,
            currentUser: {
                is_system_admin: 0,
            },
            permissionUser: null,
            userId: this.props.match.params.user_id,
        }
    }
    componentWillMount() {
        const { userId } = this.state;
        this.getUser('me');
        this.getUser(userId);
        this.getDatasources();
    }
    componentDidMount() {
        document.title = "DataDex";
    }
    getUser(userId='me') {
        api.fetchAPI({
            method: 'get',
            uri: `user/${userId}`,
            success: (response) => {
                if (response.status === 'ok') {
                    if (userId === 'me') {
                        this.setState({ currentUser: response.user });
                    } else {
                        this.setState({ permissionUser: response.user });
                    }
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    getDatasources() {
        api.fetchAPI({
            method: 'get',
            uri: 'datasources',
            success: (response) => {
                console.log(response);
                if (response.status === 'ok') {
                    this.setState({ datasources: response.datasources })
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    updatePermissions(effect='allow', action, objectType, objectId, buttonRequestMethod) {
        const { permissionUser } = this.state;
        const permissionObject = {
            user_id: permissionUser.id,
            effect,
            action,
            object_type: objectType,
            object_id: objectId,
        };

        api.fetchAPI({
            method: buttonRequestMethod,
            uri: 'permissions',
            body: permissionObject,
            success: (response) => {
                console.log(response);
                if (response.status === 'ok') {
                    this.getUser(permissionUser.id);
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    render() {
        const { datasources, currentUser, userId, permissionUser } = this.state;
        const isCurrentUserAdmin = currentUser.is_system_admin;
        
        if (isCurrentUserAdmin <= 0) return null;
        if (!permissionUser) return null;
        return (
            <div style={{ marginTop: 50 }}>
                <Row>
                    <Col xs={12}>
                        <h1>{permissionUser.first_name} {permissionUser.last_name} can</h1>
                    </Col>
                    {Constant.permissionTypes.map(permissionType => 
                        <Col xs={12} key={permissionType}>
                            {Constant.itemObjectTypes.map((objectType, index) => {
                                const permissionToCheck = permissionUser.permissions.filter(permission => permission.action === permissionType)[0];
                                
                                // We need to get the PLURAL form of the attributes
                                // Eg: if objectType = 'database', we want to extract the attributes 'databases'
                                // from the permission return
                                const objectNameToCheck = Constant.itemObjectTypesPlural[index];
                                let buttonColor = 'secondary';
                                let buttonRequestMethod = 'post';
                                if (permissionToCheck[objectNameToCheck] == '*') {
                                    buttonColor = 'success';
                                    buttonRequestMethod = 'delete'
                                }
                                return (
                                    <Button
                                        key={objectType}
                                        color={buttonColor}
                                        onClick={() => this.updatePermissions('allow', permissionType, objectType, '*', buttonRequestMethod)}
                                    >
                                        {`${permissionType} all ${objectNameToCheck}`}
                                    </Button>
                                )
                            })}
                        </Col>
                    )}
                    <br /><br /><br />
                    <Col xs={12}>
                        <h1>Or select a datasource to start</h1>
                    </Col>
                    {datasources.map(datasource =>
                        <Col xs={12}  className="user-item" key={datasource.id}>
                            <DataObject
                                userId={userId}
                                isGrantingPermission 
                                dataObject={datasource}
                            />
                        </Col>
                    )}
                    <Col xs={12}>
                        <h1>Or granting dashboard permission</h1>
                    </Col>
                    <Col xs={12}>
                        <Button
                            color="primary"
                            tag={Link}
                            to={`/dashboards/?is_granting_permission=1&user_id=${userId}`}
                        >
                            Go to dashboard permission manager
                        </Button>
                    </Col>
                </Row>
            </div>
        )
    };
}



// WEBPACK FOOTER //
// ./src/pages/UserPermissionManagement/index.js